import { setLocaleObjectNamespace } from "../../../common/src/setLocaleObjectNamespace";

export default setLocaleObjectNamespace("settings", {
    textColor: "Basic text color",
    backgroundColor: "Background color",
    fileTypeNotMatch: "The file type does not match the requirements",
    replace: "Replace",
    uploadBackgroundImage: "Upload background image",
    backgroundFixed: "Fix background image",
    backgroundFixedTooltip: "The image will only stretch within the view of the screen",
    showCountdown: "Show countdown over poster in player",
    borderRadiusSize: "Rounding corners",
    goToQuizListPage: "Open list of quizzes",
    saveSettings: "Save settings",
    view: "View",
    orientation: "Orientation",
    backgroundOpacity: "Opacity of the main background",
    additionalColor: "Secondary color",
    elementsRounding: "Element rounding",
    substrateOpacity: "Background transparency of the substrate",
    cardOpacity: "Opacity of the background of the card",
    showFormat: "Show format",
    showFormatInCards: "Show format in cards",
    showMembersPhoto: "Show photos of speakers and moderators in cards",
    showMembersGroupAndName: "Show group names and names of speakers and moderators in cards",
    showDelay: "Show breaks",
    showTags: "Show tags",
    showLogos: "Show logos",
    gridCardHeight: `Height of cards in "Grid" view`,
    gridCardHeightHint: "Pixels per minute",
    showTitle: "Show title",
    title: "Title",
    titleSize: "Title size",
    textSize: "Text size",
    showSubtitle: "Show subtitle",
    subtitle: "Subtitle",
    subtitleSize: "Subtitle size",
    typeFileName: "Enter a file name",
    uploadBackground: "Upload background",
    uploadHeader: "Upload header",
    wrongFileFormat: "Invalid file format",
    exesAllowableSize: "File size exceeds allowable size",
    backgroundImageHint: "File format jpg, png, bmp",
    confirmImageRemove: "Are you sure you want to remove the photo?",
    additionalTextColor: 'Secondary text color',
    backgroundTooltipText: "File format jpg, png, bmp",
    showDate: "Show date",
    left: "Left",
    center: "Center",
    right: "Right",
    headingPositioning: "Positioning the title and subtitle",
    goHallSettings: "Go to hall settings",
    blockPlayer: "Player",
    blockDescription: "Hall Schedule",
    blockEpisodes: "Description of the current episode",
    errorMessage: "An error occurred, please try again",
    showSubstrate: "Show substrate",
    gridCardHeightSize: "Tile height",
    gridCardHeightSizeTooltip: "Pixels per minute",
    pdfExportEnabled: "Show Download PDF button",
    showOrganizationSearch: "Show organization search",
    showStatuses: "Show status",
    showBigPhotos: "Show big photos",
    alignPhotoCenter: "Align photos to center",
    player: "Broadcast",
    showPlayerOffline: "Allow offline participants to view the broadcast",
    format: 'Format',
    a4: 'A4',
    fullpage: 'Fullpage',
    showEpisodeExpanded: 'Show cards expanded',
    placeholderTips: "Placeholder Tips",

    'delay.title': 'Delay settings',
    'delay.showTime': 'Show time',
    'delay.largeFont': 'Large font',
    'delay.cardColor': 'Card color',

    'hint.timeAndFullname': 'Time and name in cards',
    'hint.textColor': 'Hall titles in the table header, episode titles in cards, hall titles in cards, time to the left of the table',

    'color.date': 'The color of the date in the table header',
    'color.card': 'Card color',
    'color.accentStyleButton': 'Ask Question Button in Accent Color',

    'show.block': 'Show block',
    'show.formats': 'Show event format',
    'show.block.displayHall': 'Display in halls',
    'show.block.expanded': 'Show the block expanded',

    'tab.title.common': 'Common settings',
    'tab.title.blocks': 'Block settings',

    'blocks.player': 'Player',
    'blocks.hall-episodes': 'Hall Schedule',
    'blocks.hall-description': 'Episode Description',
    'blocks.legacy-banners': 'Advertising banners',
    'blocks.text-block': 'Text block',
    'blocks.buttons': 'Buttons',
    'blocks.poster': 'Poster',
    'blocks.countdown': 'Countdown',
    'blocks.activity-rating': 'Users activity rating',
    'blocks.partners': 'Partners',
    'blocks.cover': 'Cover',
    'blocks.quizzes': 'Quizzes',
    'blocks.shop': 'Prizes shop',
    'blocks.custom-widget': 'Widget',

    'add.block': 'Add new block',

    'placeholder.title': 'Enter a title title',

    'confirm.removeBlock': 'Are you sure you want to remove the block?',

    'error.blockAlreadyExists': 'There can only be one block of this type on the page',
    'scheduleButton': 'Schedule button',
    'scheduleButton.show': 'Display schedule button',
    'scheduleButton.title': 'Schedule button title',
    'pixelsInMinute': 'Pixels in minute',

    'diffStartTimeout.title': 'Show countdown to event for',
    'diffStartTimeout.hour': '1 hour',
    'diffStartTimeout.day': '1 day',
    'diffStartTimeout.week': '7 days',
    'diffStartTimeout.month': '30 days',

    'mobileOpenModule': 'Open the interactive tab on mobile devices by default',

    'question.title': 'Question settings',
    'question.hide': 'Disable display of question block',
    'question.allowReceiveQuestions': 'Enable receiving questions',

    'timeoutFormat': 'Counter format',
    'timeoutFormat.dd_hh_mm_ss': 'Days, Hours, Minutes, Seconds',
    'timeoutFormat.dd_hh_mm': 'Days, Hours, Minutes',
    'timeoutFormat.emptyVisibleDay': 'When there are 0 days left (less than 24 hours), show Hours, Minutes, Seconds',

    'partners.addPartner': 'Add partner',
    'partners.removePartner': 'Remove partner',
    'partner.title': 'Partner',
    'partner.name': 'Name',
    'partner.logo': 'Logo',
    'partner.backgroundColor': 'Background color',
    'partner.url': 'Link',

    'cover.dateEvent': 'Event date',
    'cover.showDateEvent': 'Show event date',
    'cover.timeEvent': 'Event time',
    'cover.showTimeEvent': 'Show event time',
    'cover.participationType': 'Event Format',
    'cover.showParticipationType': 'Show event format',

    'allowedPhoneCountryCodes.title': 'Allowed Phone Country Codes',
    'allowedPhoneCountryCodes.add': 'Add',
    'allowedPhoneCountryCodes.buttonOpen': 'Available countries for sending SMS',

    'webHooks.title': 'Web Hook Service',
    'webHooks.remove': 'Remove?',
    'webHooks.add': 'Add web hook',
    'webHooks.method': 'Request Method',
    'webHooks.deliveryFormat': 'Format',
    'webHooks.headers': 'Headers',
    'webHooks.addHeader': 'Add Header',
    'webHooks.key': 'Key',
    'webHooks.value': 'Value',

    'viewTypeRestriction.listType': 'List Type',
    'viewTypeRestriction.none': 'None selected',
    'viewTypeRestriction.whitelist': 'Whitelist',
    'viewTypeRestriction.blacklist': 'Blacklist',
    'viewTypeRestriction.emptyList': 'List is empty',
    'viewTypeRestriction.selectType': 'Select list type',
    'viewTypeRestriction.byIp.title': 'Restrict viewing by IP',
    'viewTypeRestriction.byIp.hint': 'Viewing will be allowed only from the selected IP and ranges',
    'viewTypeRestriction.byIp.button': 'Add IP address',
    'viewTypeRestriction.byIp.confirm': 'Are you sure you want to remove the IP address?',
    'viewTypeRestriction.byIp.validationHint': 'IP address must be of the form "192.168.1.1" or "192.168.1.0-192.168.1.24" or "192.168.1.0/24"',
    'viewTypeRestriction.byCountry.title': 'Browsing restriction by country',
    'viewTypeRestriction.byCountry.hint': 'Browsing will only be allowed from the selected countries',
    'viewTypeRestriction.byCountry.button': 'Add country',
    'viewTypeRestriction.byCountry.confirm': 'Are you sure you want to remove the selected country?',

    sidebarPosition: 'Chat position',
    bottom: 'Bottom',
    right: 'Right',
});
